import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    dialogflow_sendIntent({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'dialogflow/send-intent', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};